import { BadgeMap } from 'components/ComposableTable/generators/TextBadgeCell';

export const statusToTextBadge: BadgeMap = {
  valid: {
    color: 'paper',
    textColor: 'chalkboard',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
  not_uploaded: {
    color: 'paper',
    textColor: 'chalkboard',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
  incorrect_headers: {
    color: 'apple',
    textColor: 'whiteout',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
  invalid_rows: {
    color: 'apple',
    textColor: 'whiteout',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
  missing: {
    color: 'apple',
    textColor: 'whiteout',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
  unreadable: {
    color: 'apple',
    textColor: 'whiteout',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
};
